import React from 'react';
import { CardTW } from 'tailwindComponents/CardTW/CardTW';
import { TitleOwnershipParty } from './TitleOwnershipParty';
import { TitleOwnershipDeed } from './TitleOwnershipDeed';
import { useSelectCurrentOrder } from '../../../../selectors/order/selectCurrentOrder';
import { eTransactionCategory } from '../../../../ui-toolkit/enums/eTransactionType';
import { ePartyPurpose } from '../../../../ui-toolkit/enums/ePartyPurpose';

export const TitleOwnershipContainer: React.FC = () => {
  const { data } = useSelectCurrentOrder();
  if (data.transaction.transaction_category !== eTransactionCategory.Purchase) {
    return null;
  }
  return (
    <CardTW title={<div className="font-medium">Transfer Deed</div>}>
      <TitleOwnershipParty purpose={ePartyPurpose.seller} />
      <TitleOwnershipParty purpose={ePartyPurpose.buyer} />
      <TitleOwnershipDeed />
    </CardTW>
  );
};
